<div class="aircraft-limit-list flex flex-col gap-4"
     data-test="aircraft-limit-list"
>
  <div class="comparison-grid expanded-mode">
    @for (row of pagedRows(); track row.origami ?? row.override) {
      <div class="origami-field flex flex-col gap-4"
           [attr.data-test]="'aircraft-limit-origami-' + row.index"
      >
        @if (row.origami; as origami) {
          <ng-container [formGroup]="origami">
            <albert-select controlName="aircraftType"
                           label="Aircraft Type"
                           [disabled]="true"
                           [inputId]="'ext_aircraftType_' + row.index"
                           [options]="origamiAircraftTypeOptions()"
            />
            <albert-limit currencyControlName="currency"
                          currencyGroupName="limit"
                          layout="row"
                          limitControlName="value"
                          limitGroupName="limit"
                          limitLabel="Limit"
                          [currencyInputId]="'ext_aircraftLimitCurrency_' + row.index"
                          [disabled]="true"
                          [limitInputId]="'ext_aircraftLimit_' + row.index"
                          [showButtons]="true"
            />
          </ng-container>
        }
      </div>
      <div class="override-cell flex flex-col gap-4"
           [attr.data-test]="'aircraft-limit-override-' + row.index"
      >
        @if (row.override; as override) {
          <ng-container [formGroup]="override">
            <div class="flex items-start gap-2.5">
              <div class="grow">
                <albert-select controlName="aircraftType"
                               label="Aircraft Type"
                               [disabled]="!canEdit()"
                               [filter]="true"
                               [inputId]="'loc_aircraftType_' + row.index"
                               [options]="aircraftTypeOptions()"
                               [required]="true"
                />
              </div>
              <button class="clear-input-btn"
                      data-test="aircraft-limit-clear-aircraft-type"
                      iconOnly
                      outlined="true"
                      pButton
                      pTooltip="Clear Aircraft Type"
                      severity="secondary"
                      tooltipPosition="left"
                      type="button"
                      [disabled]="!canEdit()"
                      (click)="onClearAircraftType(row)"
              >
                <i class="pi pi-times"></i>
              </button>
            </div>
            <div class="flex items-start gap-2.5">
              <albert-limit class="grow min-w-0"
                            currencyControlName="currency"
                            currencyGroupName="limit"
                            layout="row"
                            limitControlName="value"
                            limitGroupName="limit"
                            limitLabel="Limit"
                            [currencyInputId]="'loc_aircraftLimitCurrency_' + row.index"
                            [disabled]="!canEdit()"
                            [limitInputId]="'loc_aircraftLimit_' + row.index"
                            [required]="true"
                            [showButtons]="true"
              />
              <button class="clear-input-btn"
                      data-test="aircraft-limit-clear-limit"
                      iconOnly
                      outlined="true"
                      pButton
                      pTooltip="Clear Limit"
                      severity="secondary"
                      tooltipPosition="left"
                      type="button"
                      [disabled]="!canEdit()"
                      (click)="onClearLimit(row)"
              >
                <i class="pi pi-times"></i>
              </button>
            </div>
          </ng-container>
        }
      </div>
    }

    <div class="origami-field hidden md:block"></div>
    <div class="override-cell">
      <button data-test="aircraft-limit-add"
              pButton
              severity="secondary"
              type="button"
              [disabled]="!canEdit()"
              (click)="onAddAircraft()"
      >
        Add Aircraft
      </button>
    </div>
  </div>

  @if (rows().length > rowsPerPage) {
    <p-paginator data-test="aircraft-limit-paginator"
                 [first]="first()"
                 [rows]="rowsPerPage"
                 [totalRecords]="rows().length"
                 (onPageChange)="onPageChange($event)"
    />
  }
</div>
